import { createReducer } from 'lib/utilities.js';

const initialState = {
  analytics: {
    metrics: [],
    organic_new_visitors_by_month: [],
    sessions_by_month: [],
    social_sources: [],
    devices: [],
    user_locations: [],
    top_landing: [],
    page_views: [],
    events: [],
  },
};

const containsData = (data) => {
  if (data) {
    if (Array.isArray(data)) {
      if (data.length) {
        return data;
      }
      return null;
    }
  }
  return data;
};

export default createReducer(initialState, {
  CRM_FETCH_ANALYTICS_METRICS_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, metrics: containsData(payload) },
    };
  },
  CRM_FETCH_ANALYTICS_ORGANIC_NEW_VISITORS_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: {
        ...state.analytics,
        organic_new_visitors_by_month: containsData(payload),
      },
    };
  },
  CRM_FETCH_ANALYTICS_SESSIONS_BY_MONTH_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: {
        ...state.analytics,
        sessions_by_month: containsData(payload),
      },
    };
  },
  CRM_FETCH_ANALYTICS_SOCIAL_SOURCES_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: {
        ...state.analytics,
        social_sources: containsData(payload),
      },
    };
  },
  CRM_FETCH_ANALYTICS_DEVICES_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: {
        ...state.analytics,
        devices: containsData(payload),
      },
    };
  },
  CRM_FETCH_ANALYTICS_USER_LOCATIONS_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: {
        ...state.analytics,
        user_locations: containsData(payload),
      },
    };
  },
  CRM_FETCH_ANALYTICS_TOP_LANDING_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: {
        ...state.analytics,
        top_landing: containsData(payload),
      },
    };
  },
  CRM_FETCH_ANALYTICS_PAGE_VIEWS_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: {
        ...state.analytics,
        page_views: containsData(payload),
      },
    };
  },
  CRM_FETCH_ANALYTICS_EVENTS_SUCCESS: (state, payload) => {
    return {
      ...state,
      analytics: {
        ...state.analytics,
        events: containsData(payload),
      },
    };
  },

  // Failed states
  CRM_FETCH_ANALYTICS_METRICS_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, metrics: 'failed' },
    };
  },
  CRM_FETCH_ANALYTICS_ORGANIC_NEW_VISITORS_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, organic_new_visitors_by_month: 'failed' },
    };
  },
  CRM_FETCH_ANALYTICS_SESSIONS_BY_MONTH_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, sessions_by_month: 'failed' },
    };
  },
  CRM_FETCH_ANALYTICS_SOCIAL_SOURCES_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, social_sources: 'failed' },
    };
  },
  CRM_FETCH_ANALYTICS_DEVICES_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, devices: 'failed' },
    };
  },
  CRM_FETCH_ANALYTICS_USER_LOCATIONS_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, user_locations: 'failed' },
    };
  },
  CRM_FETCH_ANALYTICS_TOP_LANDING_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, top_landing: 'failed' },
    };
  },
  CRM_FETCH_ANALYTICS_PAGE_VIEWS_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, page_views: 'failed' },
    };
  },
  CRM_FETCH_ANALYTICS_EVENTS_FAIL: (state, payload) => {
    return {
      ...state,
      analytics: { ...state.analytics, events: 'failed' },
    };
  },
});
